import 'apps/hiring/styles/sections/opening/settings.scss';
import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { Redirect } from 'library/util/core-router';
import PropTypes from 'prop-types';
import { jsonToInputParams } from 'library/util/graph';
import HiringQuery from 'apps/hiring/util/query';
import withData from 'util/hoc/with-data';
import Loading from 'components/loading';
import Confirm from 'library/helpers/confirm';
import SavingButton from 'library/components/saving-button';
import AddBehaviors from 'apps/hiring/components/add-behaviors';
import EditEmployeelist from 'apps/hiring/components/edit-employees-list';
import withConfig from 'util/hoc/with-config'

class CloseOpening extends React.Component {
  static propTypes = {
    closed: PropTypes.bool,
    id: PropTypes.number,
    graph_data: PropTypes.object,
    graph_loading: PropTypes.object,
    reloadOpening: PropTypes.func
  }

  state = {
    redirect: null
  }

  closeOrActivateOpening = async () => {
    const params = {
      id: this.props.id,
      settings: {
        closed: !this.props.closed
      }
    };

    if (resolve(params, 'settings/closed', false) && !(await Confirm('Are you sure?'))) {
      return;
    }

    const { data } = await HiringQuery(`
      mutation {
        update_opening (${jsonToInputParams(params)}) {
          success
        }
      }
    `);

    if (resolve(data, 'update_opening/success', false)) {
      this.props.reloadOpening(true, true);
    }
  }

  render() {
    return (
      <div className="hiring-close-opening">
        <button className={this.props.closed?'button-auxilary-2':'button-auxilary-5'} onClick={this.closeOrActivateOpening}>
          {this.props.closed ? 'Reactivate Opening' : 'Close Opening'}
        </button>
        {
          this.state.redirect
            ? <Redirect to={this.state.redirect} />
            : null
        }
      </div>
    );
  }
}

class OpeningSettings extends React.Component {
  state = {
    edits: {}
  }

  handleEdit = (e) => {
    const { name, value } = e.target;
    const { edits } = {...this.state};

    edits[name] = value;

    this.setState({
      edits: edits
    });
  }

  get hasChanges() {
    return Object.values(this.state.edits).filter(c=>c).length;
  }

  saveRemovedUsers = async (type) => {
    const id = resolve(this.props, 'graph_data/opening/id', null);
    const usersToRemove = resolve(this.props, `graph_data/opening/${type}/results`, [])
      .filter(r=>( resolve(this.state, `edits/${type}`, resolve(this.props, `graph_data/opening/${type}/results`, [])).findIndex(v=>v.id===r.id) === -1)).map(t=>t.id);
    if (!usersToRemove.length) return;

    const allThingsG0 = [];
    let userType = 'Employee';
    if (type == 'managers') userType = 'Manager';

    for (const user of usersToRemove) {
      const params = {
        node_id: id,
        user_id: user,
        user_type: userType
      };

      const { data } = await HiringQuery(`
        mutation {
          remove_user_from_node (${jsonToInputParams(params)}) {
            success
          }
        }
      `);
      allThingsG0.push(data.remove_user_from_node.success);
    }
    if (!allThingsG0.includes(false)) this.props.reloadOpening(true, true);
  }

  mapRemovedTargets = ({ id, name }) => ( this.mapRemovedOptions({ id, name}, this.reAddTarget))

  mapRemovedUsers = ({ id, name }) => ( this.mapRemovedOptions({ id, name }, this.reAddUsers))

  mapRemovedManagers = ({ id, name }) => ( this.mapRemovedOptions({ id, name }, this.reAddUsers))

  reAddUsers = (val) => {
    const users = resolve(this.state, 'edits/users', []);
    this.reAddOptions(users,'users', val);
  }

  reAddManagers = (val) => {
    const managers = resolve(this.state, 'edits/managers', []);
    this.reAddOptions(managers,'managers', val);
  }

  reAddTarget = (val) => {
    const targets = resolve(this.state, 'edits/targets', []);
    this.reAddOptions(targets,'targets', val);
  }

  mapRemovedOptions = (option, addFunc) => (
    <div key={option.id} className="hiring-behavior-row hiring-behavior-row-removed">
      <span>{ option.name }</span>
      <div>
        <button disabled={this.props.disabled} onClick={()=>addFunc({ id:option.id, name:option.name })}>ADD</button>
      </div>
    </div>
  );

  mapRemoved = ({ id, name }) => (
    <div key={id} className="hiring-behavior-row hiring-behavior-row-removed">
      <span>{ name }</span>
      <div>
        <button disabled={this.props.disabled} onClick={()=>this.reAddTarget({id:id,name:name})}>ADD</button>
      </div>
    </div>
  )

  reAddOptions = (arr, name, val) => {
    arr.push(val);
    this.handleEdit({
      target: {
        name: name,
        value: arr
      }
    });
  }

  saveOpeningData = async () => {
    const id = resolve(this.props, 'graph_data/opening/id', null);
    const name = resolve(this.state, 'edits/name', resolve(this.props, 'graph_data/opening/name', ''));

    try {
      await HiringQuery(`
        mutation {
          update_opening (${jsonToInputParams({id:id,name:name})}) {
            success
          }
        }
      `);
    } catch (e) {
      console.error(e);
    }
  }

  saveRemovedTargets = async () => {
    const id = resolve(this.props, 'graph_data/opening/id', null);
    const targetsToRemove = resolve(this.props, 'graph_data/opening/target_groupings/results', [])
      .filter(r=>(
        resolve(
          this.state,
          'edits/targets',
          resolve(this.props, 'graph_data/opening/target_groupings/results', [])
        ).findIndex(v=>v.id===r.id) === -1)
      ).map(t=>t.id);

    if (!targetsToRemove.length) return;

    for (const t of targetsToRemove) {
      await HiringQuery(`
        mutation {
          disconnect_target (${jsonToInputParams({id: t, connectable_id: id, connectable_type: 'node'})}) {
            success
          }
        }
      `);
    }
  }

  saveAddedTargets = async () => {
    const id = resolve(this.props, 'graph_data/opening/id', null);
    const targetsToAdd = resolve(this.state, 'edits/targets', []).filter(r=>(
      resolve(this.props, 'graph_data/opening/target_groupings/results', []).findIndex(x=>x.id===r.id) === -1
    )).map(t=>t.id);

    if (!targetsToAdd.length) return;

    const params = {
      ids: targetsToAdd,
      connectable_id: id,
      connectable_type: 'node'
    };

    await HiringQuery(`
      mutation {
        connect_targets (${jsonToInputParams(params)}) {
          success
        }
      }
    `);
  }

  handleAddEmployees = async (users, type='Employee') => {
    if (!users) return;

    for (const user of users){
      const params = {
        node_id: Number(resolve(this.props, 'graph_data/opening/id', null)),
        user_id: Number(user.id),
        user_type: type
      };

      try {
        await HiringQuery(`
          mutation {
            add_user_to_node(${jsonToInputParams(params)}){
              success,
              errors
            }
          }
          `);
      } catch (e) {
        console.error(e);
      }
    }

    this.props.reloadOpening(true);
  }

  save = async () => {
    this.setState({
      saving: true
    });

    await this.saveRemovedUsers('users');
    await this.saveRemovedUsers('managers');
    await this.handleAddEmployees(resolve(this.state, 'edits/users', null), 'Employee');
    await this.handleAddEmployees(resolve(this.state, 'edits/managers', null), 'Manager');
    await this.saveOpeningData();
    await this.saveRemovedTargets();
    await this.saveAddedTargets();

    this.props.reloadOpening(true, true);

    this.setState({
      saving: false
    });
  }

  render() {
    const {
      graph_data,
      graph_loading,
      reloadOpening,
      configuration
    } = this.props;

    const {
      edits,
      saving
    } = this.state;

    if (graph_loading) {
      return <Loading />;
    }

    const closed = resolve(graph_data, 'opening/closed', '');

    const removed = resolve(graph_data, 'opening/target_groupings/results', [])
      .filter(r=>(
        resolve(
          edits,
          'targets',
          resolve(graph_data, 'opening/target_groupings/results', [])
        ).findIndex(v=>v.id===r.id) === -1)
      );

    const removedUsers = resolve(graph_data, 'opening/users/results', []).filter(r => (resolve(edits,'users', resolve(graph_data, 'opening/users/results', [])).findIndex(v=>v.id===r.id) === -1));
    const removedManagers = resolve(graph_data, 'opening/managers/results', []).filter(r => (resolve(edits,'managers', resolve(graph_data, 'opening/managers/results', [])).findIndex(v=>v.id===r.id) === -1));


    return (
      <Fragment>
        <div className="hiring-body">
          <section className="hiring-section">
            <div className="hiring-opening-settings">
              <section disabled={closed} className="hiring-opening-settings-section">
                <h2>Edit Opening</h2>
                <label>
                  Name
                  <input
                    type="text"
                    name="name"
                    onChange={this.handleEdit}
                    value={resolve(edits, 'name', resolve(graph_data, 'opening/name', ''))}
                    disabled={closed}
                  />
                </label>
              </section>

              <section className="hiring-opening-settings-section">
                <EditEmployeelist
                  surveyed
                  title={`Add Employees to ${resolve(graph_data, 'opening/name', 'this opening')}`}
                  addType='users'
                  onChange={this.handleEdit}
                  users={resolve(edits, 'users', resolve(graph_data, 'opening/users/results', []))}
                />
                {
                  removedUsers.map(this.mapRemovedUsers)
                }
              </section>

              <section className="hiring-opening-settings-section">
                <EditEmployeelist
                  title={`Add Managers to ${resolve(graph_data, 'opening/name', 'this opening')}`}
                  addType='managers'
                  onChange={this.handleEdit}
                  users={resolve(edits, 'managers', resolve(graph_data, 'opening/managers/results', []))}
                />
                {
                  removedManagers.map(this.mapRemovedManagers)
                }
              </section>

              <section disabled={closed} className="hiring-opening-settings-section">
                <AddBehaviors
                  disabled={closed}
                  onChange={this.handleEdit}
                  targets={resolve(edits, 'targets', resolve(graph_data, 'opening/target_groupings/results', []))}
                />
                {
                  removed.map(this.mapRemoved)
                }
              </section>

              {
                resolve(configuration, 'apps/hiring/configuration/show_opening_uuid', false) &&
                <section className="hiring-opening-settings-section">
                  <h2 style={{ fontWeight: 400 }}>UUID:
                    <small> {graph_data.opening.uuid} </small>
                  </h2>
                </section>
              }

              <div style={{marginBottom: '1em'}}>
                <SavingButton saving={saving} disabled={closed||!this.hasChanges} onClick={this.save}>Save</SavingButton>
              </div>
              <div className="flex-spacer" />
              <section className="hiring-opening-settings-section">
                <CloseOpening reloadOpening={reloadOpening} closed={closed} id={resolve(graph_data, 'opening/id', '')} />
              </section>
            </div>
          </section>
        </div>
      </Fragment>
    );
  }
}

OpeningSettings.propTypes = {
  graph_data: PropTypes.object,
  graph_loading: PropTypes.bool,
  reloadOpening: PropTypes.func,
  disabled: PropTypes.bool,
  configuration: PropTypes.object
};

OpeningSettings.query = (token, { match }) => (
  HiringQuery(`
    {
      opening (id: ${match.params.id}) {
        id,
        name,
        uuid,
        closed,
        settings {
          invitation_token
        }
        managers {
          results {
            name
            id
            first_name
            last_name
            email
          }
        }
        users(has_surveyed: true) {
          pagination {
            limit
            offset
            total
          }
          results {,
            name
            id
            first_name
            last_name,
            email,
            assessment (completed: true) {
              id
              progress
              completion_date
              scored
            }
          }
        }
        target_groupings (limit:1000){
          results {
            id,
            name
          }
        }
      }
    }
  `)
);

export default withConfig(withData(OpeningSettings));
